<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Token calls",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Token calls",
            items: [
               {
                  text: "Token calls",
                  active: true,
               },                   
            ],

            sales: [],            
            clinics: [],            
            doctors: [],
            pagination: {},
            calls: [],
            
            from_date: current_date,
            to_date: current_date,
            keyword: "",
            doctor_id: "",
            clinic_id: "",
            listing_length: 10,
            status: '',
            type: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchTokenCalls();
         this.fetchClinics();
         this.fetchDoctors();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         clearForm() {
               this.errors = {};  
         },
         fetchTokenCalls() {  
            let url = "api/admin/clinics/doctor/allTokenCalls?date=" + this.from_date + "&doctor_id=" + this.doctor_id + "&clinic_id=" + this.clinic_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.calls = responseData.calls;
               })
               .catch((err) => console.log(err));
         },

       
         downloadConsultationsExcel() {
            let url = "api/admin/consultation_excel_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&status=" + this.status + "&type=" + this.type;     
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" // Specify blob response type
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "consultation_report.xlsx";
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },

         
         fetchClinics() {
                let url = "api/admin/getClinics";         
                this.getToken();
                this.$axios
                    .get(url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.clinics = responseData.clinics;
                    })
                    .catch((err) => console.log(err));
         },
       fetchDoctors() {
                let url = "api/admin/getDoctors";         
                this.getToken();
                this.$axios
                    .get(url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.doctors = responseData.doctors;
                    })
                    .catch((err) => console.log(err));
            },


         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },  

         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-3">
                        <label>Choose Date <span class="text-danger">*</span></label>
                        <!-- <b-form-input type="date" ></b-form-input> -->
                        <input type="date" v-model="from_date" class="form-control"  @change="fetchTokenCalls" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }">
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                      <div class="form-group col-lg-3">
                        <label>Doctor</label>
                        <select class="form-control" @change="fetchTokenCalls()" v-model="doctor_id" :class="{ 'is-invalid': Boolean(errors.doctor_id) }">
                           <option value="">Select</option>
                           <option :value="doctor.id" v-for="doctor in doctors" :key="doctor.id">{{ doctor.name }}</option>
                        </select>
                        </div>

                        <div class="form-group col-lg-3">
                        <label class="control-label">Clinics</label>
                        <select class="form-control" @change="fetchTokenCalls()" v-model="clinic_id" :class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                           <option value="">Select</option>
                           <option :value="clinic_list.id" v-for="clinic_list in clinics" :key="clinic_list.id">{{ clinic_list.name }}</option>
                        </select>
                        </div>

                    
                  </div>
                  <!----- filters area ends---->

                  <!-----  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button" @click="fetchConsultations()">View</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadConsultationsPdf()">Download PDF</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadConsultationsExcel()">Download Excel</button>                     </div>
                  </div>---->
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                 
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                         
                              <tr>
                              <th width="15%">Doctor</th>
                              <th width="15%">Clinic</th>
                              <th width="15%">Tv</th> 
                              <th width="15%">Token</th>              
                              <th width="15%">Count</th>
                              <th width="15%">Last Called On</th>

                           </tr>
                          
                        </thead>
                        <tbody v-if="Boolean(calls.length)">
                           <tr v-for="call in calls" :key="call.id">
                             <td>
                                 {{call.prefix}}{{call.doctor_name}}
                              </td><td>
                                 {{call.clinic_name}}
                              </td>
                              <td>{{call.name}}<br>
                                
                              </td>  
                              <td>{{call.token}}<br>
                                
                              </td>                       
                              <td>
                                 {{call.count}}
                              </td>
                               <td>
                                 {{call.updated_at| formatDateTime }}
                              </td>
                            
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="4" class="text-center">No Token Calls found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
